<template>
  <!-- Div que cubre toda la pantalla -->
  <v-dialog :model-value="dialog" @update:model-value="closeCard" hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5">Tarjeta</span>
        <v-btn icon @click="closeCard">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- Main de la tarjeta como tal -->
        <v-row>
          <!-- Header de la tarjeta -->
          <v-col cols="12">
            <div class="trellocard-header">
              <!-- Título -->

              <!-- Estado de la tarea -->
              <div>
                <p>
                  en la lista 
                  <v-chip :color="getStateColor(localCard.state)" dark>{{ localCard.state }}</v-chip>
                </p>
              </div>
            </div>
          </v-col>

          <!-- Body -->
          <v-col cols="9">
            <!-- Columna 1 (contenido) -->
            <div class="trellocard-column">
              <!-- Descripción en markdown del contenido de la tarjeta -->
              <v-row>
                <v-textarea
                  v-model="localCard.description"
                  label="Descripción"
                  outlined
                  auto-grow
                ></v-textarea>
              </v-row>
              <v-row v-if="project.options.isAgile">
                <v-banner>
                  Sprint Id: 
                    <v-chip color="primary" text-color="white">
                      {{ localCard.sprint ? localCard.sprint : 'No asignado' }}
                    </v-chip>
                </v-banner>
              </v-row>
            </div>
          </v-col>

          <!-- Columna 2 (acciones) -->
          <v-col cols="3">
            <div class="trellocard-second-column trellocard-column field-group">
              <v-text-field
                v-model="puntaje"
                label="Estimación"
                type="number"
                outlined
              ></v-text-field>
              <v-btn color="primary" @click="guardar">Guardar</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeCard">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api.js';

export default {
  name: "TrelloCard",
  props: {
    card: {
      type: Object,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      puntaje: 0,
      localCard: { ...this.card } // Crear una copia local de la tarjeta para evitar mutar la prop directamente
    }
  },
  computed: {
    project() {
      return this.$store.state.project;
    }
  },
  methods: {
    getStateColor(state) {
      const columns = this.$store.state.project.kanbanColumns;
      const colors = ['blue', 'orange', 'green', 'red', 'purple', 'yellow']; // Add more colors if needed
      const index = columns.indexOf(state);
      return index !== -1 ? colors[index % colors.length] : 'grey';
    },
    async getSprint(card){
      try{
        const response = await api.get(`/api/sprint/${card.sprint}`);
        this.sprint = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    closeCard() {
      this.$emit('update:dialog', false);
    },
    async guardar() {
      // Detectar si hubo cambios en el objeto
      if(this.localCard.description === this.card.description && this.puntaje === this.card.puntaje) {
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'No se detectaron cambios en la tarjeta.',
            color: 'info',
            icon: 'mdi-information'
          }
        );
        this.$emit('update:dialog', false);
        return;
      }

      const obj = {
        ...this.localCard,
        puntaje: this.puntaje
      }

      try {
        const res = await api.put(`/api/element/update/${this.localCard._id}`, obj);
        console.log(res);
        if (res.status == 200) {
          this.$store.commit(
            'setSnackbar', 
            {
              text: 'El puntaje ha sido actualizado correctamente.',
              color: 'success',
              icon: 'mdi-check-circle'
            }
          );
          this.$emit('update:dialog', false);
          const obj = this.localCard;
          obj.puntaje = this.puntaje;
          this.$socket.emit('event_update_element', {
            room: this.$route.params.projectId,
            user: localStorage.getItem('email'),
            element: obj
          });

          // Actualizar el sprint
          await this.updateSprint(obj);

          // Actualizar data que contiene el componente <NewSprint>
          this.$store.commit('updateProductBacklog', obj);
          this.$store.commit('updateSprintBacklog', obj);

        } else {
          this.$store.commit(
            'setSnackbar', 
            {
              text: 'Hubo un error al actualizar el puntaje.',
              color: 'error',
              icon: 'mdi-alert'
            }
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateSprint(element) {
      try {
        const sprintId = element.sprint;
        if(!sprintId) {
          return;
        }

        const response = await api.get(`/api/sprint/${sprintId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        const sprint = response.data;
        console.log('sprint que llegó:', sprint);

        // Actualizar el total de puntos del sprint
        sprint.totalPoints = Number(sprint.totalPoints) + Number(element.puntaje);
        console.log('sumando el puntaje: ', sprint.totalPoints);

        // Si solo hay un registro en el historial, agregar un nuevo registro
        if (sprint.history.length === 1) {
          const initialPoints = sprint.history[0].pointsLeft;
          const pointsLeft = initialPoints - element.puntaje;

          const newHistoryEntry = {
            date: new Date(),
            pointsLeft: pointsLeft,
          };

          sprint.history.push(newHistoryEntry);
        }

        await api.put(`/api/sprint/${sprintId}`, sprint, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        console.log('Sprint actualizado:', sprint);
      } catch (error) {
        console.error('Error al actualizar el sprint:', error);
      }
    },
  },
  created() {
    this.puntaje = this.card.puntaje ? this.card.puntaje : 0;
  }
}
</script>

<style scoped>
.trellocard-fullscreen {
  width: 100vw;
  height: 100vh;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  overflow: auto;
  z-index: 101;
  justify-content: center;
  align-items: center;
}

.trellocard-container {
  position: relative;
  width: auto;
  padding: 20px;
  margin: 48px 0;
  background: trasparent;
  outline: 0;
  overflow: visible;
  border-radius: 12px;
  min-height: 600px;
  min-width: 800px;
  background-color: #323940;
  color: #b6c2cf;
}

.trellocard-header p {
  font-size: 14px;
}

.trellocard-body {
  display: flex;
}

.trellocard-column {
  margin-inline: 5px;
}

.trellocard-second-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.trellocard-titulo-div {
  width: 100%;
}

.trellocard-titulo-div textarea {
  width: 100%;
  background-color: #323940;
  color: #b6c2cf;
  border: none;
  font-size: 20px;
  padding: 10px;
  resize: none;
}

.trellocard-titulo-div textarea:focus {
  background-color: #22272b;
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
  outline: 1px solid #85b8ff;
}

.trellocard-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

input {
  padding: 10px;
  border-radius: 5px;
  border: none;
  background-color: #45505a;
  font-weight: 600;
  color: #b6c2cf;
}
</style>